module.exports = __webpack_public_path__ + "img/empty_property_icon.71aed637.svg";